import { createApiCaller, createApiClient } from "./client";
import { BASE_URL_AUTH } from "../constants";

const client = createApiClient(BASE_URL_AUTH);

export default createApiCaller(client);
